// The workspace is selected only from the signed Firebase token, never from
// local storage, a query string, or a profile field a client can edit.
export async function resolveERPWorkspace(user, databaseFor) {
  if (!user) return { db: databaseFor('(default)'), isReview: false };
  const token = await user.getIdTokenResult();
  const isReview = token.claims.erpReview === true;
  return { db: databaseFor(isReview ? 'erp-review' : '(default)'), isReview };
}

export function workspaceUploadPath(path, { isReview, uid }) {
  if (typeof path !== 'string' || !path || path.startsWith('/') || path.includes('://') || path.split('/').some(part => part === '..' || part === '.')) {
    throw new Error('Use a valid ERP upload path.');
  }
  if (!isReview) return path;
  if (!uid || uid.includes('/')) throw new Error('Sign in to the sample workspace again.');
  return `erp_review/${uid}/${path}`;
}
